import {useState, useEffect} from 'react';

const useWindowLandscape = () => {
  const media = window.matchMedia('(orientation: landscape)');

  const [isLandscape, setLandscape] = useState(media.matches);

  function handler(mediaQuery: MediaQueryListEvent) {
    setLandscape(mediaQuery.matches);
  }

  useEffect(() => {
    media.addEventListener('change', handler);

    return () => media.removeEventListener('change', handler);
  }, [isLandscape]);

  return isLandscape;
};

export default useWindowLandscape;
